/* global google */

let marker: google.maps.marker.AdvancedMarkerElement | null;
const GOOGLE_MAPS_MAP_ID = "fbf33b73110f45a0";

const Geolocation = (function () {
  function generatePositionString(lat: number, lng: number) {
    return `${lat},${lng}`;
  }

  async function createMarker(map: google.maps.Map, lat: number, lng: number) {
    if (marker) marker.map = null;
    marker = null;

    const { AdvancedMarkerElement } = (await google.maps.importLibrary(
      "marker",
    )) as google.maps.MarkerLibrary;
    marker = new AdvancedMarkerElement({
      map,
      gmpDraggable: true,
      title: "Din plats",
      position: { lat, lng },
    });

    map.panTo({ lat, lng });

    const latLngInput = document.getElementsByClassName(
      "js-lat-lng-input",
    )[0] as HTMLInputElement;
    latLngInput.value = generatePositionString(lat, lng);
  }

  function init() {
    $(function () {
      let map: google.maps.Map, infoWindow: google.maps.InfoWindow;

      async function initMap() {
        if (typeof google === "undefined") return;

        const { Map } = (await google.maps.importLibrary(
          "maps",
        )) as google.maps.MapsLibrary;

        map = new Map(document.getElementById("map")!, {
          center: { lat: 59.34670058506868, lng: 18.0328344018449 },
          zoom: 16,
          streetViewControl: false,
          mapId: GOOGLE_MAPS_MAP_ID,
        });
        infoWindow = new google.maps.InfoWindow();

        const locationButton = document.getElementById("findPositionButton")!;

        locationButton.addEventListener("click", () => {
          // Try HTML5 geolocation.
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              async (position) => {
                const pos = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                };

                const latLngInput = document.getElementsByClassName(
                  "js-lat-lng-input",
                )[0] as HTMLInputElement;

                latLngInput.setAttribute("data-marker-type", "automatic");

                await createMarker(map, pos.lat, pos.lng);

                marker?.addListener(
                  "dragend",
                  (e: google.maps.MapMouseEvent) => {
                    latLngInput.value = generatePositionString(
                      e.latLng!.lat(),
                      e.latLng!.lng(),
                    );
                    latLngInput.setAttribute("data-marker-type", "manual");
                  },
                );
              },
              () => {
                handleLocationError(true, infoWindow, map.getCenter()!);
              },
            );
          } else {
            // Browser doesn't support Geolocation
            handleLocationError(false, infoWindow, map.getCenter()!);
          }
        });

        map.addListener("click", async (e: google.maps.MapMouseEvent) => {
          await createMarker(map, e.latLng!.lat(), e.latLng!.lng());
          document
            .getElementsByClassName("js-lat-lng-input")[0]
            .setAttribute("data-marker-type", "manual");
        });
      }

      function handleLocationError(
        browserHasGeolocation: boolean,
        infoWindow: google.maps.InfoWindow,
        pos: google.maps.LatLng,
      ) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
          browserHasGeolocation
            ? "Det gick inte att hitta dig. Tryck på kartan för att markera var rullburen är."
            : "Din webbläsare stödjer inte geolokalisering. Tryck på kartan för att markera var rullburen är.",
        );
        infoWindow.open(map);
      }

      window.initMap = initMap;
      window.initMap();
    });
  }

  return {
    init,
  };
})();

export default Geolocation;
